import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createSlots as _createSlots, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, renderList as _renderList } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "dashboards-indicator-cards"
}
const _hoisted_2 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DashboardsCard = _resolveComponent("DashboardsCard")!
  const _component_DashboardsCardsWrapper = _resolveComponent("DashboardsCardsWrapper")!
  const _component_Loader = _resolveComponent("Loader")!

  return (_ctx.isCardsWithGrid)
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        (_ctx.isLoadingCards || _ctx.getRegionStatisticWithLinks.length)
          ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
              (!_ctx.isLoadingCards && _ctx.getRegionStatisticWithLinks.length)
                ? (_openBlock(), _createBlock(_component_DashboardsCardsWrapper, {
                    key: 0,
                    items: _ctx.getRegionStatisticWithLinks,
                    itemKey: "title"
                  }, {
                    default: _withCtx(({ item }) => [
                      _createVNode(_component_DashboardsCard, {
                        card: item,
                        year: _ctx.year,
                        link: item.link,
                        isLoading: _ctx.isLoadingCards,
                        isShowAPPG: _ctx.isShowAPPG,
                        isClickable: _ctx.getIsClickable(item.originalIndex),
                        onClick: ($event: any) => (_ctx.clickByCard(item.originalIndex)),
                        variant: _ctx.variant,
                        indicatorsColor: _ctx.indicatorsColor
                      }, _createSlots({ _: 2 }, [
                        (_ctx.isShowTooltip && _ctx.getTooltipText(item.originalIndex))
                          ? {
                              name: "tooltip",
                              fn: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.getTooltipText(item.originalIndex)), 1)
                              ]),
                              key: "0"
                            }
                          : undefined
                      ]), 1032, ["card", "year", "link", "isLoading", "isShowAPPG", "isClickable", "onClick", "variant", "indicatorsColor"])
                    ]),
                    _: 1
                  }, 8, ["items"]))
                : (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _createVNode(_component_Loader, { isCenterWidth: "" })
                  ]))
            ]))
          : _createCommentVNode("", true)
      ], 64))
    : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.getRegionStatisticWithLinks, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          key: item.title
        }, [
          _createVNode(_component_DashboardsCard, {
            card: item,
            year: _ctx.year,
            link: item.link,
            isLoading: _ctx.isLoadingCards,
            isShowAPPG: _ctx.isShowAPPG,
            isClickable: _ctx.getIsClickable(item.originalIndex),
            onClick: ($event: any) => (_ctx.clickByCard(item.originalIndex)),
            variant: _ctx.variant,
            indicatorsColor: _ctx.indicatorsColor
          }, _createSlots({ _: 2 }, [
            (_ctx.isShowTooltip && _ctx.getTooltipText(item.originalIndex))
              ? {
                  name: "tooltip",
                  fn: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.getTooltipText(item.originalIndex)), 1)
                  ]),
                  key: "0"
                }
              : undefined
          ]), 1032, ["card", "year", "link", "isLoading", "isShowAPPG", "isClickable", "onClick", "variant", "indicatorsColor"])
        ]))
      }), 128))
}